import {
  ApplicationId,
  clientIdentification
} from '@gjensidige/service-client-identification';

export const APPLICATION_ID = clientIdentification.getApplicationId();

export const IS_PRIVAT = APPLICATION_ID === ApplicationId.Internett;

export const SELECTED_PARTREF =
  clientIdentification.getSelectedPartref() ||
  window.ChatStickyConfig.selectedPartref;

export enum CallRequest {
  COMMENT = 'Chatten stengt',
  AVAILABILITY_URL = '/api-kundeservice/open/callguide/v2/{entrance}/{menuchoice}/is-open',
  REQUEST_URL = '/api-kundeservice/open/callguide/v2/callback'
}

export const phoneNumberRegex = /^(\+47)?\d{8}$/;
